import Service from "@/services/modules/configurations.service";

const save = async (context) => {
  const response = Service.save(context.state.model);

  return response;
};

const all = async ({ commit }) => {
  const response = Service.all();

  response.then(function(_response) {
    commit("setModel", _response);
  });

  return response;
};

export default {
  save,
  all,
};
